export const useVideoPlaceholderStyles = () => {
  return {
    wrapper: {
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.1s ease-in-out',
    },
    localPlaceholder: {
      position: 'absolute',
      borderRadius: '50%',
      bgcolor: 'rgba(255, 255, 255, 0.2)',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'opacity 0.01s ease-in-out',
    },
  };
};
